import { CardMedia } from '@mui/material';

const LogoName = 'motilal-wealth.svg';

const mobileWidth = '160px';
const desktopWidth = '200px';

export function LoginLogo(): JSX.Element {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Motilal Oswal Logo"
      sx={{
        width: mobileWidth,
        '@media (min-width: 768px)': { width: desktopWidth },
        my: 2.5,
        mx: { xs: 1, md: 3 },
      }}
    />
  );
}

export function DashboardLogo(): JSX.Element {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Motilal Oswal Logo"
      sx={{ width: mobileWidth, '@media (min-width: 768px)': { width: desktopWidth } }}
    />
  );
}

export function EditApplicationLogo(): JSX.Element {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Motilal Oswal Logo"
      sx={{
        width: mobileWidth,
        '@media (min-width: 768px)': { width: desktopWidth },
        m: 3,
        my: 0.7,
      }}
    />
  );
}
